import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, HostListener, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/@core/services/notification.service';
import { ProgressBarService } from 'src/@core/services/progress-bar.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatPaginator,
  MatSort,
  MatTableDataSource
} from '@angular/material';
import { BehaviorSubject, Subscription, merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { Search } from 'src/@core/interfaces/search';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { JobService } from 'src/@core/services/job/job.service';
import { Job } from 'src/@core/interfaces/job/job.model';
import { AppService, CURRENT_USER } from 'src/@core/services/app.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions'
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { NavigationExtras, Router } from '@angular/router';
import { LocalStorageService } from 'src/@core/services/local-storage.service';
import { STATUS } from 'src/app/shared/helpers/status';
import moment from 'moment';
import { CompareQuotesComponent } from '../compare-quotes/compare-quotes.component';
import { CreateQuoteComponent } from '../create-quote/create-quote.component';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GET_QUOTATION } from 'src/@core/services/util/api.endpoints';
import { CreatePurchaseOrderComponent } from '../../purchase-orders/create-purchase-order/create-purchase-order.component';
import { SignContractPopupComponent } from '../../sign-contract-popup/sign-contract-popup.component';

@Component({
  selector: 'hour4u-admin-quote-list',
  templateUrl: './quote-list.component.html',
  styleUrls: ['./quote-list.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ]
})
export class QuoteListComponent implements OnInit {
  dataChange: BehaviorSubject<any>;
  @Input() data?: any;
  @Input() vendorView?: boolean = false;
  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  resultsLength = 0;
  title = 'Job';
  columns = [
    { columnDef: 'checkbox', visible: true, label: 'Checkbox' },
    { columnDef: 'quoteId', visible: true, label: 'Quote ID' },
    { columnDef: 'agencyName', visible: true, label: 'Agency Name' },
    { columnDef: 'status', visible: true, label: 'Status' },
    { columnDef: 'finalAmount', visible: true, label: 'Final Amount' },
    { columnDef: 'paymentTerms', visible: true, label: 'Payment Terms' },
    { columnDef: 'validity', visible: true, label: 'Validity' },
    { columnDef: 'action', visible: true, label: 'Action' },
  ];
  displayedColumns = this.columns.map(x => x.columnDef);
  profile = this.appService.getCurrentAccount();
  pageSize = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  prevUrl: String;
  searchParams: Array<Search> = [];
  loginUserDetails: any = null;
  row: any;
  sort_field: string = '';
  diameter = 40;
  color: string;
  mode = 'indeterminate';
  status = STATUS;
  selectedAgency: any = null;
  selectedCreatedOn: any = null;
  selectedCreatedBy: any = null;
  selectedExpiredBy: any = null;
  agenciesList: any[] = [];
  createdByList: any[] = [];
  selection = new SelectionModel<any>(true, []);
  allRowsSelected: boolean = false;
  isLoading: boolean = false;
  quoteList: any[] = [];
  screenWidth = window.innerWidth;
  showSendQuoteBtnToVendor: boolean = false;

  @Output() refreshParent = new EventEmitter<any>();

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }
  arrayQuotes: any[] = [];
  subscrier: Subscription;

  constructor(private dialog: MatDialog,
    private service: JobService,
    private jobTypeService: JobTypeService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private notify: NotificationService,
    private progress: ProgressBarService,
    private appService: AppService,
    private _localStorageService: LocalStorageService,
    private http: HttpClient) {

    this.subscrier = this.service.getRefreshQuotePage().subscribe(res => {
      this.getQuotesData(this.vendorView);
    });
  }

  ngOnInit() {
    this.dataChange = new BehaviorSubject(0);
    this.getQuotesData(this.vendorView);
    console.log(this.vendorView)
    console.log(this.profile)
    // this.getAssignedAgenciesAndCreatedByArray();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  // get Quotes Data
  getQuotesData(vendorView) {
    this.isLoading = true;
    const sort = 'createdOn,desc';
    this.quoteList = [];
    const httpParams = new HttpParams()
      .set('sort', sort)
      .set('jobId', this.data.id.toString())
      .set('vendorView', vendorView.toString())
    // .set('size', this.pageSize.toString())

    this.http.get<any>(GET_QUOTATION, { params: httpParams }).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && Array.isArray(response)) {
          if (response && response.length) {
            response.forEach(element => {
              if (element.quoteConditions && element.quoteConditions.expiryDate) {
                element.quoteConditions.quoteValidity = element.quoteConditions.expiryDate;
              }
              element.totalCost = 0;
              // element.status = 0;
              if (element.jobRateCards && element.jobRateCards.length) {
                element.jobRateCards.forEach(ele => {
                  element.totalCost = element.totalCost + ele.totalAmount;
                  // element.totalUnits = element.totalUnits + ele.quantity;
                });
              }

              if (element.variableJobRateCards && element.variableJobRateCards.length) {
                element.variableJobRateCards.forEach(ele1 => {
                  element.totalCost = element.totalCost + ele1.totalAmount;
                });
              }

              element.totalCost = element.totalCost * 1.18;

              // element.assignedEntitiesName = [];
              // if (element.assignedEntities && element.assignedEntities.length) {
              //   element.assignedEntities.forEach(ele => {
              //     element.assignedEntitiesName.push(ele.name);
              //   });
              // }

            });
          }
          this.quoteList = response;
          console.log("this.quoteList", this.quoteList)
          this.resultsLength = this.quoteList.length;
          this.selection.clear();
          this.quoteList.forEach(row => this.selection.select(row));
        }
        if (this.data && this.data.billingType == 'NONE') {
          this.columns = this.columns.map(x => {
            x.visible = true;
            if (x.columnDef === 'finalAmount' || x.columnDef === 'paymentTerms')
              x.visible = false;
            return x;
          });
          this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch bookings:', error);
      }
    );
  }

  // getAssignedAgenciesAndCreatedByArray() {
  //   this.searchParams = [];
  //   const entityId = this.profile.entity.id;

  //   if (entityId) {
  //     this.service.getAssignedAgenciesAndCreatedByArray(entityId
  //     ).subscribe(data => {
  //       console.log(data)
  //       this.agenciesList = data.addedEntityIds;
  //       this.createdByList = data.createdBy;
  //       console.log(this.agenciesList)
  //     }, (error: any) => {
  //       this.notify.showMessage(error.error.message, 2000);
  //     });
  //   } else {
  //     console.warn('Entity ID is not available. Unable to fetch agencies.');
  //   }
  // }

  reloadTable() {
    // this.dataChange.next(1);
  }

  search(data?) {
    // this.searchParams = [];
    // if (data) {
    //   this.searchParams.push(new Search('title', data));
    // }
    // if (this.currentUserRole == 'ENTERPRISE_ADMIN') {
    //   this.searchParams.push(new Search('employerId', JSON.parse(localStorage.getItem(CURRENT_USER)).entity.id))
    // } else {
    //   this.searchParams.push(new Search('entityId', JSON.parse(localStorage.getItem(CURRENT_USER)).entity.id))
    // }
    // // this.searchParams.push(new Search('code', data));
    // this.dataChange.next(1);
  }

  sortData(direction) {
    this.sort.active = 'createdOn';
    this.sort.direction = direction.value;
    this.sort.sortChange.next();
  }

  viewQuote(row) {
    console.log(row)
    this.router.navigateByUrl('/job/quote/' + row.id);
  }

  dataRefresh() {
    this.ngOnInit();
  }

  filterBy() {
    this.searchParams = [];

    // if (this.selectedAgency && this.selectedAgency.length) {
    //   this.selectedAgency.forEach(element => {
    //     this.searchParams.push(new Search("entityIds", element));
    //   });
    // }
    // if (this.selectedCreatedBy && this.selectedCreatedBy.length) {
    //   this.selectedCreatedBy.forEach(element => {
    //     this.searchParams.push(new Search("createdBy", element));
    //   });
    // }
    // if (this.selectedCreatedOn) {
    //   this.searchParams.push(new Search("createdOn", moment(this.selectedCreatedOn).format('YYYY-MM-DD')));
    // }
    this.getQuotesData(this.vendorView);
  }

  // create PO
  createPO(row) {
    // alert("Coming Soon...")
    // return
    console.log("row", row)
    // row.projectData = this.data;
    let data = Object.assign({}, this.data);
    data.quoteDetails = row;
    data.action = "Create";
    data.withQuote = true;
    data.vendorId = row.sendByUserDetails.id;

    const dialogRef = this.dialog.open(CreatePurchaseOrderComponent, {
      width: '1024px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: data,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getQuotesData(this.vendorView);
        this.refreshParent.emit();
      }
    });
  }

  createWorkOrder() {
    const navigationExtras: NavigationExtras = {
      queryParams: { 'jobId': this.data.id, 'jobTypeId': this.data.jobTypeId, 'employerId': this.data.employerId }
    }
    this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  }

  // edit Field
  editQuote(row) {
    row.action = 'Edit';
    const dialogRef = this.dialog.open(CreateQuoteComponent, {
      width: '1024px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: row,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getQuotesData(this.vendorView);
      }
    });
  }

  // compare All Quotes
  compareAllQuotes() {
    let data: any = Object.assign({}, this.selection);
    let arrayQuotes = [];
    data._selected.forEach(element => {
      this.quoteList.forEach(el => {
        if (element.id == el.id) {
          arrayQuotes.push(el)
        }
      })
    });
    const dialogRef = this.dialog.open(CompareQuotesComponent, {
      // width: '1024px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: arrayQuotes,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh();
      }
    });
  }

  // accept Reject Quote
  acceptRejectQuote(data, status) {
    this.data.quoteStatusChangeCalled = false;
    if (status == 'ACCEPTED' && data && data.signatureRequired) {
      this.data.quoteStatusChangeCalled = true;
      this.openSignContractPopUp(data);
    } else {
      this.service.updateQuoteStatus(data.id, status).subscribe(res => {
        this.dataRefreshIndividualRow(res);
        this.notify.showMessage('Quotation Status Updated Successfully!', 2000);
      }, ((err: any) => {
        this.notify.showMessage(err.error.message, 2000);
      }))
    }
  }

  openSignContractPopUp(row) {
    console.log(row)
    row.quoteStatusChangeCalled = true;
    // let obj = {
    //   selectedQuote: row,
    //   selectedProject: this.data
    // }
    this.data.selectedProject = Object.assign({}, this.data);
    this.data.selectedQuote = row;
    localStorage.setItem("selectedPojectData", JSON.stringify(this.data));
    if (this.data.id) {
      this.router.navigate(['/job/signed-doc/' + this.data.id]);
    } else {
      this.router.navigate(['/job/signed-doc']);
    }

    // const dialogRef = this.dialog.open(SignContractPopupComponent, {
    //   width: '600px',
    //   panelClass: 'assign-dialog',
    //   disableClose: true,
    //   data: obj
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.dataRefresh();
    //   }
    // });
  }

  // refresh individual row
  dataRefreshIndividualRow(res) {
    this.quoteList.forEach((ele: any, index) => {
      if (ele.id == res.id) {
        ele.totalCost = 0;
        if (ele.jobRateCards && ele.jobRateCards.length) {
          ele.jobRateCards.forEach(ele1 => {
            ele.totalCost = ele.totalCost + ele1.totalAmount;
          });
        }

        if (ele.variableJobRateCards && ele.variableJobRateCards.length) {
          ele.variableJobRateCards.forEach(ele1 => {
            ele.totalCost = ele.totalCost + ele1.totalAmount;
          });
        }
        ele.totalCost = ele.totalCost * 1.18;
        res.totalCost = ele.totalCost;
        this.quoteList[index] = res;
        this.quoteList = [...this.quoteList];
        // if (this.isAllSelected()) {
        this.selection.clear();
        this.quoteList.forEach(row => this.selection.select(row));
        // }
        console.log(this.quoteList)
        this.cdRef.detectChanges();
      }
    })
  }

  // Select all rows 
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.quoteList.length;
    this.arrayQuotes = [];
    let data: any = Object.assign({}, this.selection);
    if (data._selected && data._selected.length) {
      data._selected.forEach(element => {
        this.quoteList.forEach(el => {
          if (element.id == el.id) {
            this.arrayQuotes.push(el)
          }
        })
      });
    }
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.quoteList.forEach(row => this.selection.select(row));
    this.isAllSelected() ? this.allRowsSelected = true : this.allRowsSelected = false;
  }

  ngOnDestroy() {
    this.subscrier.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.vendorView && !changes.vendorView.firstChange) {
      // Perform actions based on changes in vendorView
      this.getQuotesData(this.vendorView);
    }
  }
}


